
























































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { DocConvenzione } from "../../_models/docConvenzione";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class ConvenzioneAlternanzaSign extends Vue {
  @Prop() docInfo!: DocConvenzione;
  @Prop() soggetto!: string;
  private firmaAzienda: string;

  constructor() {
    super();
    this.firmaAzienda = "";
  }

  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }

  close() {
    bus.$emit("closeDocSignDialog");
    // bus.$emit("closeConvenzione");
  }

  save() {
    //dispatchSignConvenzione
    var signatureAziendaEmpty: boolean = true;
    //@ts-ignore
    const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
    if (signatureAzienda.isEmpty === false) {
      const payload = {
        idConvenzione: this.docInfo.idConvenzione,
        firmaAzienda: signatureAzienda.data
      };

      user
        .dispatchSignConvenzione(this["$store"], payload)
        .then(() => {
          bus.$emit("successfullOperation", "Convenzione Firmata con successo");
          bus.$emit("loadConvenzione");
          this.close();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("errorOperation", "Firma Legale Rappresentante mancante");
    }
  }
}
